import type { JobTitleI, JobTitleFilterI } from 'types';
import { BaseApi } from './base-api';
import { fetchData } from 'Utils/fetch-data';

class JobTitlesApi extends BaseApi<JobTitleI, JobTitleFilterI> {
  async patch(id: string, data: { status: boolean }) {
    const response = await fetchData<{ status: boolean }>(`${this.endpoint}/${id}`, {
      method: 'PATCH',
      data,
    });
    return response;
  }
}

const jobTitlesApi = new JobTitlesApi('/job-titles');

export default jobTitlesApi;
